<template>
  <v-dialog max-width="200px" v-model="dialog" @keydown.enter.prevent="close">
    <v-card>
      <v-card-title/>
      <v-card-text>
        <v-row dense>
          <v-col cols="6">
            <v-text-field :label="labelTileX" v-model.number="value.x" hide-details/>
          </v-col>
          <v-col cols="6">
            <v-text-field :label="labelTileY" v-model.number="value.y" hide-details/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on }">
      <v-text-field
          v-model.trim="text"
          :label="label"
          readonly
          v-on="on"
          hide-details
          clearable
          @click:clear="clear"
      />
    </template>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {Tile} from "@/modules/redactor/models/utils/Tile";


export default {
  name: "r-tile",
  props: {
    model: VueTypes.instanceOf(Tile),
    label: VueTypes.string.def("Tile"),
    labelTileX: VueTypes.string.def("Tile X:"),
    labelTileY: VueTypes.string.def("Tile Y:"),
  },
  data: () => ({
    dialog: false,
    text: null
  }),
  methods: {
    checkChange() {
      this.text = this.value.string;
    },
    close() {
      if (this.value.empty() || this.value.valid()) {
        this.dialog = false;
      }
    },
    clear() {
      this.$emit("update:model", null);
    }
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new Tile();
        this.$emit("update:model", value);
        return value;
      }
    }
  },
  mounted() {
    this.checkChange()
  },
  watch: {
    dialog() {
      this.checkChange();
    },
    value() {
      this.checkChange();
    }
  }
}

</script>